import React from 'react';
import { Box, CssBaseline, Typography, useTheme } from '@mui/material';
import AppIcon from '../../assets/logo/colegio_aleman.png';

const BAR_HEIGHTS = [0.45, 0.8, 0.55, 1, 0.65, 0.9, 0.5, 0.75, 0.4, 0.85];

const LoadingScreen: React.FC = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        bgcolor: theme.palette.primary.main,
        position: 'relative',
        overflow: 'hidden',
        '&::before': {
          content: '""',
          position: 'absolute',
          inset: 0,
          backgroundImage: `
            linear-gradient(rgba(255,255,255,0.04) 1px, transparent 1px),
            linear-gradient(90deg, rgba(255,255,255,0.04) 1px, transparent 1px)
          `,
          backgroundSize: '48px 48px',
          pointerEvents: 'none',
        },
      }}
    >
      <CssBaseline />

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          zIndex: 1,
        }}
      >
        {/* Logo */}
        <Box
          component="img"
          src={AppIcon}
          alt="Colegio Alemán"
          sx={{
            height: 72,
            mb: 3,
            '@keyframes logoFadeIn': {
              from: { opacity: 0, transform: 'translateY(-14px) scale(0.88)' },
              to: { opacity: 1, transform: 'translateY(0) scale(1)' },
            },
            animation: 'logoFadeIn 0.9s cubic-bezier(0.22, 1, 0.36, 1) forwards',
          }}
        />

        {/* Waveform bars */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'flex-end',
            gap: '5px',
            height: '34px',
            mb: 4,
          }}
        >
          {BAR_HEIGHTS.map((h, i) => (
            <Box
              key={i}
              sx={{
                width: '3px',
                borderRadius: '1.5px',
                bgcolor: 'rgba(255,255,255,0.78)',
                transformOrigin: 'bottom center',
                height: `${h * 100}%`,
                '@keyframes wave': {
                  '0%, 100%': { transform: 'scaleY(0.22)', opacity: 0.28 },
                  '50%': { transform: 'scaleY(1)', opacity: 0.9 },
                },
                animation: `wave 1.5s ease-in-out ${i * 0.1}s infinite`,
              }}
            />
          ))}
        </Box>

        {/* Cargando label */}
        <Typography
          sx={{
            color: 'rgba(255,255,255,0.38)',
            fontSize: '0.6rem',
            letterSpacing: '0.55em',
            textTransform: 'uppercase',
            fontFamily: '"Courier New", Courier, monospace',
            '@keyframes breathe': {
              '0%, 100%': { opacity: 0.38 },
              '50%': { opacity: 0.15 },
            },
            animation: 'breathe 2.4s ease-in-out infinite',
          }}
        >
          Cargando
        </Typography>
      </Box>

      {/* Bottom progress sweep */}
      <Box
        sx={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          height: '2px',
          background: 'rgba(255,255,255,0.45)',
          '@keyframes sweep': {
            '0%': { width: '0%', opacity: 1 },
            '80%': { width: '88%', opacity: 1 },
            '100%': { width: '100%', opacity: 0 },
          },
          animation: 'sweep 2.2s ease-in-out infinite',
        }}
      />
    </Box>
  );
};

export default LoadingScreen;
